import React from "react";
//import React, { useState } from "react";

const Register = props => {
  // const [user, setUser] = useState({
  //   Name: "",
  //   Surname: "",
  //   EmailAddress: "",
  //   Password: "",
  //   Password2: ""
  // });

  return <div></div>;
};

export default Register;
